import { SocietyCorporateId } from 'types/Society';

const hasLimitedVersion =
  process.env.REACT_APP_UI_CORPORATE_ID === SocietyCorporateId.AXA;

export default [
  !hasLimitedVersion
    ? {
        id: 'my-profile',
        icon: 'ni-user-alt',
        text: 'MyProfile',
        url: '/perfil-usuario/datos',
      }
    : null,
].filter(Boolean);
